import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { authAPI } from '../../services/api';

const AuthGuard = ({ children }) => {
  const { loading: authLoading, isAuthenticated, logout } = useAuth();
  const { isDark } = useTheme();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [validatingAuth, setValidatingAuth] = useState(true);

  useEffect(() => {
    // Validate authentication on mount
    const validateAuth = async () => {
      if (isAuthenticated) {
        try {
          await authAPI.validateToken();
          setValidatingAuth(false);
        } catch (error) {
          console.log('Token validation failed in AuthGuard');
          logout();
        }
      } else {
        setValidatingAuth(false);
      }
    };

    validateAuth();

    // Listen for auth transitions
    const handleBeforeUnload = () => {
      setIsTransitioning(true);
    };

    // Check if we're in a redirect state
    const checkRedirect = () => {
      if (!localStorage.getItem('accessToken') && window.location.pathname !== '/') {
        setIsTransitioning(true);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    checkRedirect();

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isAuthenticated, logout]);

  // Show loading state during auth initialization or transitions
  if (authLoading || isTransitioning || validatingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="glass-spinner w-12 h-12 mx-auto mb-4"></div>
          <p className={`text-mono text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
            {isTransitioning ? 'Redirecting...' : 'Loading...'}
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthGuard;